import {
  DASHBOARD_LAYOUT_REQUEST,
  DASHBOARD_LAYOUT_SUCCESS,
  DASHBOARD_LAYOUT_FAILURE,
  DASHBOARD_LAYOUT_SAVE_SUCCESS,
  DASHBOARD_LAYOUT_RESET_SUCCESS,
} from '../types'

// Keyed by dashboardType ('admin' | 'user') rather than split into two
// reducers - the Admin and User Analytics Dashboards' layout state is
// genuinely symmetric (same shape, same actions), unlike
// adminAnalyticsReducer/userAnalyticsReducer which carry very different
// dashboard payloads.
const INITIAL_SLICE = { status: 'idle', layout: null, error: null }
const INITIAL_STATE = { admin: INITIAL_SLICE, user: INITIAL_SLICE }

const dashboardLayoutReducer = (state = INITIAL_STATE, { type, payload } = {}) => {
  const dashboardType = payload?.dashboardType
  if (!dashboardType || !(dashboardType in INITIAL_STATE)) return state

  const slice = state[dashboardType] || INITIAL_SLICE

  switch (type) {
    case DASHBOARD_LAYOUT_REQUEST:
      return { ...state, [dashboardType]: { ...slice, status: 'loading', error: null } }
    case DASHBOARD_LAYOUT_SUCCESS:
      return { ...state, [dashboardType]: { ...slice, status: 'success', layout: payload.layout, error: null } }
    case DASHBOARD_LAYOUT_FAILURE:
      return { ...state, [dashboardType]: { ...slice, status: 'error', error: payload.error || null } }
    case DASHBOARD_LAYOUT_SAVE_SUCCESS:
      return { ...state, [dashboardType]: { ...slice, layout: payload.layout } }
    case DASHBOARD_LAYOUT_RESET_SUCCESS:
      return { ...state, [dashboardType]: { ...slice, layout: null } }
    default:
      return state
  }
}

export default dashboardLayoutReducer
